module.exports = "<browser-check></browser-check>\r\n<div *ngIf=\"this.currentUserService.browserOk\">\r\n  <div class=\"banner-container\">\r\n    <faceted-search-app-banner></faceted-search-app-banner>\r\n  </div>\r\n  <div *ngIf=\"this.currentUserService.user\" class=\"body-container\">\r\n    <router-outlet>\r\n    </router-outlet>\r\n  </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main